
<template>
    <div class="van-doc-demo-block__card">
        <p class="tip">
            喜悦发布将尽全力保护您的个人信息安全，并保障您在个人信息处理过程中的相关权益。为了向您提供喜悦发布的基本功能及附加功能，我们需要收集您在使用服务时通过您主动授权/提供等方式产生的个人信息。以下我们将逐一说明收集情况，方便您快速查阅。
        </p>
        <router-link
            tag="div"
            :to="{ name: 'SellerBasicInformation' }"
            class="van-hairline--bottom"
        >
            <div
                role="button"
                tabindex="0"
                class="van-cell van-cell--clickable"
            >
                <div class="van-cell__title">
                    <span class="title">用户基本信息</span>
                </div>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
        </router-link>
        <!-- query: { token: router.query.token,phone:router.query.phone } -->
        <router-link
            tag="div"
            :to="{ name: 'SellerIdentityInformation'}"
            class="van-hairline--bottom"
        >
            <div
                role="button"
                tabindex="0"
                class="van-cell van-cell--clickable"
            >
                <div class="van-cell__title">
                    <span class="title">用户身份信息</span>
                </div>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
        </router-link>
        <router-link
            tag="div"
            :to="{ path: 'SellerLocationInformation'}"
            class="van-hairline--bottom"
        >
            <div
                role="button"
                tabindex="0"
                class="van-cell van-cell--clickable"
            >
                <div class="van-cell__title">
                    <span class="title">位置信息</span>
                </div>
                <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>
        </router-link>

        <!-- 下边线 -->
        <div tabindex="0" class="van-cell">
            <div class="van-cell__title">
                <span></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {},
};
</script>
<style lang="scss" scoped>
.tip {
    font-size: 16px;
    color: #999;
    text-indent: 30px;
    margin: 10px;
}
.title {
    color: #333333;
    font-size: 15px;
}
</style>